/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
//Plan type and rebate program
export const GET_PLAN_TYPE_DATA = 'GET_PLAN_TYPE_DATA';
export const REFRESH_OUTSTANDING_BALANCE_BY_LABERER_AND_QTR_DISPLAY =
  'REFRESH_OUTSTANDING_BALANCE_BY_LABERER_AND_QTR_DISPLAY';
export const GET_ERROR_MSG_OUTSTANDING_BAL_LABERER_QTR =
  'GET_ERROR_MSG_OUTSTANDING_BAL_LABERER_QTR';
export const GET_MANUFACTURERS_OUTSTANDING_DISPUTES_QUARTER =
  'GET_MANUFACTURERS_OUTSTANDING_DISPUTES_QUARTER';
export const SET_SELECTED_RESULT_OUTSTANDING_DISPUTES_QUARTER =
  'SET_SELECTED_RESULT_OUTSTANDING_DISPUTES_QUARTER';
export const GET_OUTSTANDING_DISPUTES_QUARTER_HEADER =
  'GET_OUTSTANDING_DISPUTES_QUARTER_HEADER';
export const IS_LOADING = 'IS_LOADING';
export const SET_OUTSTANDING_BAL_BY_LABERER_AND_QUARTER =
  'SET_OUTSTANDING_BAL_BY_LABERER_AND_QUARTER';
export const REFRESH_OUTSTANDING_BALANCE_BY_LABERER_AND_QTR =
  'REFRESH_OUTSTANDING_BALANCE_BY_LABERER_AND_QTR';
